<template>
	<div
		class="scroll-rotate-container"
		ref="container"
	>
		<img
			:src="parsedImage.url"
			alt="Rotating Image"
			class="rotating-image"
			:style="{ transform: `rotate(${rotationAngle}deg)` }"
		/>
	</div>
</template>

<script>
export default {
	props: {
		image: {
			type: String,
			required: true,
		},
	},
	data() {
		return {
			rotationAngle: 0, // Initial rotation angle
			velocity: 5, // Degree change per scroll event
			lastScrollY: 0, // Track the last scroll position
			timeout: null, // For debouncing animation
		};
	},
	mounted() {
		// Attach scroll event listener when the component is mounted
		window.addEventListener('scroll', this.handleScroll);
	},
	computed: {
		parsedImage() {
			if (this.image) {
				return JSON.parse(this.image);
			} else {
				return null;
			}
		},
	},

	beforeDestroy() {
		// Cleanup scroll event listener
		window.removeEventListener('scroll', this.handleScroll);
	},
	methods: {
		handleScroll() {
			const currentScrollY = window.scrollY;

			// Determine scroll direction
			if (currentScrollY > this.lastScrollY) {
				// Scrolling down
				this.rotationAngle += this.velocity;
			} else if (currentScrollY < this.lastScrollY) {
				// Scrolling up
				this.rotationAngle -= this.velocity;
			}

			this.lastScrollY = currentScrollY;

			// Debounce the scroll event for smoother, snappier animation
			if (this.timeout) clearTimeout(this.timeout);
			this.timeout = setTimeout(() => {
				this.velocity = 5; // Reset velocity after the scroll stops
			}, 100); // Adjust timeout for desired responsiveness
		},
	},
};
</script>

<style scoped>
.scroll-rotate-container {
	display: flex;
	justify-content: flex-start;
	align-items: center;
	overflow: hidden;
	margin-top: 40px;
}

.rotating-image {
	max-width: 300px; /* Adjust image size as needed */
	max-height: 300px;
	height: auto;
  transition: transform 0.2s cubic-bezier(0.22, 1, 0.36, 1); /* "Springy" ease-out */
}
</style>
